//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery'
import img1 from '../assets/img/1.jpg'
import img2 from '../assets/img/2.jpg'
import img3 from '../assets/img/3.jpg'
import img4 from '../assets/img/4.jpg'
import img5 from '../assets/img/5.jpg'
import img6 from '../assets/img/6.jpg'
import img7 from '../assets/img/7.jpg'
import img8 from '../assets/img/8.jpg'
import img9 from '../assets/img/9.jpg'
import img10 from '../assets/img/10.jpg'
import img11 from '../assets/img/11.jpg'

export default {
  components: {

  },
  data () {
    return {
      user: '',
      leng: 0,
      index: 0,
      imgel: [],
      imgurl: {
        img1: img1,
        img2: img2,
        img3: img3,
        img4: img4,
        img5: img5,
        img6: img6,
        img7: img7,
        img8: img8,
        img9: img9,
        img10: img10,
        img11: img11
      }
    }
  },
  methods: {
    btnclick () {
      $('audio#img-music')[0].pause()
      $('audio#memory-music')[0].play()
      let url = '/memories'
      this.$router.push({ path: url })
    },
    feiru () {
      if (this.leng === 0 && this.index === 0) {
        return
      }
      if (this.leng > this.index) {
        setTimeout(this.feirucore, 4000)
      } else {
        setTimeout(this.showEndBtn, 4000)
      }
    },
    feirucore () {
      this.animateFct()
      console.log(this.index)
      this.index++
      this.feiru()
    },
    showEndBtn () {
      $('.end').fadeIn(3000)
    },
    animateFct () {
      let i = this.index
      let li = this.imgel
      var randTBArr = ['top', 'bottom']
      var randLRArr = ['right', 'left']
      var data = {}
      var c = Math.floor((Math.random() * 2) + 1)
      li.eq(i).css(randTBArr[c - 1], '-100%')
      var d = Math.floor((Math.random() * 2) + 1)
      li.eq(i).css(randLRArr[d - 1], '-100%')
      li.eq(i).css('z-index', i)
      var n = Math.floor((Math.random() * 30) + (-30))
      li.eq(i).css({transform: 'rotate(' + n + 'deg)'})
      li.eq(i).find('img').css({width: '250px', height: '350px'})
      li.eq(i).show()
      if (parseInt(li.eq(i).css('top')) < 0) {
        data.top = parseInt(Math.random() * 20 + 5) + '%'
      }
      if (parseInt(li.eq(i).css('left')) < 0) {
        data.left = parseInt(Math.random() * 15 + 5) + '%'
      }
      if (parseInt(li.eq(i).css('right')) < 0) {
        data.right = parseInt(Math.random() * 15 + 5) + '%'
      }
      if (parseInt(li.eq(i).css('bottom')) < 0) {
        data.bottom = parseInt(Math.random() * 30 + 15) + '%'
      }
      li.eq(i).stop().animate(data, 3000)
    }
  },
  mounted () {
    let li = $('.img-li')
    this.leng = li.length
    this.imgel = li
    this.feiru()
  }
}



// WEBPACK FOOTER //
// ./src/components/Img.vue